export default __webpack_public_path__ + "static/media/share.89140ad1.svg";